import { useQuery } from '@apollo/client'
import { GetHomeGenresDocument, GetHomeGenresQuery, RootCategory } from '~/__generated__/graphql'
import browserEnv from '~/libs/env/browserEnv'

const devCategoryIds = [
  {
    rootId: '1', // ジャンル
    subIds: [
      '7', // ヒューマンドラマ
      '3', // シリアス
      '4', // コメディ
      '2', // ホラー / スリラー
      '50', // コント
      '6', // SF / ファンタジー
      '5', // ドキュメンタリー
      '53', // アニメーション
      '42', // ロマンス
      '43', // サスペンス
      '41', // ブラック・ユーモア
    ],
  },
  {
    rootId: '114', // 上映時間
    subIds: [
      '19', //5分以内
      '33', //5分 - 10分の作品
      '34', //10分 - 15分の作品
      '35', //15分 - 20分の作品
      '36', //20分 - 25分の作品
      '116', //25分 - 30分の作品
      '117', //30分以上
    ],
  },
  {
    rootId: '18', // その他
    subIds: [
      '20', // 新作
      '112', // もうすぐ配信終了
      '31', // SAMANSAスタッフ推し作品！
      '111', // SNSで話題！
    ],
  },
]

const prodCategoryIds = [
  {
    rootId: '1', // ジャンル
    subIds: [
      '7', // ヒューマンドラマ
      '3', // シリアス
      '4', // コメディ
      '2', // ホラー / スリラー
      '50', // コント
      '6', // SF / ファンタジー
      '5', // ドキュメンタリー
      '53', // アニメーション
      '42', // ロマンス
      '43', // サスペンス
      '13', // ハートフル
      '41', // ブラック・ユーモア
      '40', // 実話を基にした作品
    ],
  },
  {
    rootId: '114', // 上映時間
    subIds: [
      '19', //5分以内
      '33', //5分 - 10分の作品
      '34', //10分 - 15分の作品
      '35', //15分 - 20分の作品
      '36', //20分 - 25分の作品
      '116', //25分 - 30分の作品
      '117', //30分以上
    ],
  },
  {
    rootId: '147', // その他
    subIds: [
      '20', // 新作
      '63', // SAMANSAの定番作品
      '112', // もうすぐ配信終了
      '142', // アカデミー賞作品
      '31', // SAMANSAスタッフ推し作品！
      '111', // SNSで話題！
      '143', // ＜SSTRUCK＞ SAMANSAオリジナル
      '47', // 先週の人気作品
      '146', // 先月の人気作品
    ],
  },
]

export function useGenreList(): RootCategory[] | 'loading' {
  const { data, error } = useQuery<GetHomeGenresQuery>(GetHomeGenresDocument)
  if (error) throw error
  if (!data) return 'loading'

  const categoryIdsByRoot =
    browserEnv.NEXT_PUBLIC_ENV === 'production' ? prodCategoryIds : devCategoryIds

  const result = categoryIdsByRoot
    .map(({ rootId, subIds }) => {
      const rootCategory = data.rootCategories.find(({ id }) => id === rootId)
      if (!rootCategory || !rootCategory.categories) return null

      // subIdsの順序でソート
      const sortedCategories = subIds
        .map((subId) => rootCategory.categories?.find((category) => category.id === subId))
        .filter((category) => category !== undefined)

      return {
        ...rootCategory,
        categories: sortedCategories,
      }
    })
    .filter((rootCategory) => rootCategory !== null) as RootCategory[]

  return result
}
